module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-layout', {
    staticClass: "elevation-1 visao-geral",
    attrs: {
      "row": "",
      "wrap": "",
      "pa-4": ""
    }
  }, [_c('v-flex', {
    staticClass: "box-title",
    attrs: {
      "xs12": ""
    }
  }, [_c('strong', [_vm._v("Visão geral")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "icone",
    attrs: {
      "xs6": "",
      "sm6": "",
      "md3": ""
    },
    on: {
      "click": _vm.pedidos
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/vs-pedidos.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.countOrders) + " pedidos")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "icone",
    attrs: {
      "xs6": "",
      "sm6": "",
      "md3": ""
    },
    on: {
      "click": _vm.itens
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/vs-itens.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.countItens) + " Itens")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "icone",
    attrs: {
      "xs6": "",
      "sm6": "",
      "md3": ""
    },
    on: {
      "click": _vm.avaliacoes
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/vs-avaliacao.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.countRating) + " Avaliações")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "icone",
    attrs: {
      "xs6": "",
      "sm6": "",
      "md3": ""
    },
    on: {
      "click": _vm.agendamento
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/vs-agendamento.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.countSchedules) + " Agendamentos")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aaff3c16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/inicio/overview.vue
// module id = 768
// module chunks = 3